var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorldcupCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 72025"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 351 (Stroke)",
    d: "M0 6.5C0 2.91015 2.91015 0 6.5 0C7.46621 0 8.38539 0.211329 9.21183 0.59116L8.50365 2.13226C7.8948 1.85242 7.2169 1.69565 6.5 1.69565C3.84663 1.69565 1.69565 3.84663 1.69565 6.5C1.69565 9.15337 3.84663 11.3043 6.5 11.3043C9.15337 11.3043 11.3043 9.15337 11.3043 6.5H13C13 10.0899 10.0899 13 6.5 13C2.91015 13 0 10.0899 0 6.5Z",
    fill: "var(--fill-0, #3B5CD2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8 (Stroke)",
    d: "M14 2.15578L7.13328 9L3 4.88027L4.15958 3.72449L7.13328 6.68844L12.8404 1L14 2.15578Z",
    fill: "var(--fill-0, #3B5CD2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldcupCheck);
export default __webpack_public_path__ + "static/media/worldcup-check.556c8be83fd7275792dccdce8ebff554.svg";
export { ForwardRef as ReactComponent };